import { render, staticRenderFns } from "./OffworkRuleEditor.vue?vue&type=template&id=05c17018"
import script from "./OffworkRuleEditor.vue?vue&type=script&lang=js"
export * from "./OffworkRuleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports